import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { ContentsItem } from '../../modules/editor/types';
import { parseStyle } from '../../util/parseStyle';

// 콘텐트 컴포넌트
import Base from './Content/Base';
import Permalink from './Content/Permalink';
import Header from './Content/Header';
import Share from './Content/Share';
import Sns from './Content/Sns';
import Map from './Content/Map';
import Video from './Content/Video';
import Footer from './Content/Footer';
import Partition from './Content/Partition';
import Shop from './Content/Shop';
import Donation from './Content/Donation';
import Htmlcode from './Content/Htmlcode';

type Props = {
	contentItem: ContentsItem,
	key: number,
};

function Content({ contentItem }: Props) {

	const screenMode = useSelector((state: RootState) => state.editor.ui.screenMode);

	const boxStyle = () => {
		const noPadCategory = ['base', 'shop', 'donation'];
		const notAllowd = noPadCategory.includes(contentItem.content.category) ? ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'padding'] : [];
		const bs = Array.isArray(contentItem.content.style[0]) ? contentItem.content.style[0][0].box : contentItem.content.style[0].box;	

		const filtered = Object.keys(bs)
		.filter(key => !notAllowd.includes(key))
		.reduce((obj:any, key:string) => {
			obj[key] = bs[key];
			return obj;
		}, {});

		return filtered;
	}	

	return (
		<div 
			className={contentItem.content.column.length === 2 && screenMode !== 'mobile' ? 'content-outer col2' : 'content-outer col1'}
		>
			<div 
				className="content-inner"
				style={parseStyle(boxStyle())}
			>
				{
					contentItem.content.category === 'base' && (
						<Base
							contentItem={contentItem}
						></Base>
					) 
				}
				{
					contentItem.content.category === 'permalink' && (
						<Permalink
							contentItem={contentItem}
						></Permalink>
					)
				}
				{
					contentItem.content.category === 'header' && (
						<Header
							contentItem={contentItem}
						></Header>
					)
				}
				{
					contentItem.content.category === 'share' && (
						<Share
							contentItem={contentItem}
						></Share>
					)
				}
				{
					contentItem.content.category === 'sns' && (
						<Sns
							contentItem={contentItem}
						></Sns>
					)
				}
				{
					contentItem.content.category === 'map' && (
						<Map
							contentItem={contentItem}
						></Map>
					)
				}
				{
					contentItem.content.category === 'video' && (
						<Video
							contentItem={contentItem}
						></Video>
					)
				}
				{
					contentItem.content.category === 'footer' && (
						<Footer
							contentItem={contentItem}
						></Footer>
					)
				}
				{
					contentItem.content.category === 'partition' && (
						<Partition
							contentItem={contentItem}
						></Partition>
					)
				}
				{
					contentItem.content.category === 'shop' && (
						<Shop
							contentItem={contentItem}
						></Shop>
					)
				}
				{
					contentItem.content.category === 'donation' && (
						<Donation
							contentItem={contentItem}
						></Donation>
					)
				}
				{
					contentItem.content.category === 'htmlcode' && (
						<Htmlcode
							contentItem={contentItem}
						></Htmlcode>
					)
				}
			</div>
		</div>
	);
}

export default Content;